var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2010_5783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2969 14.6562H21.8906V11.8438H16.7011L13.1908 6.88006C13.9181 6.00462 15.3601 3.92539 15.3601 1.20312V0.5H14.6569C12.3465 0.5 11.1728 0.748906 10.0377 0.989563C8.93522 1.22328 7.89399 1.44411 5.77308 1.44847L4.96988 1.45011L5.07778 2.246C5.30049 3.88873 6.00502 5.23198 6.61074 6.12495H6.38119C5.55075 6.12495 4.79499 5.63516 4.45585 4.87723L4.19757 4.30002L2.91389 4.87433L3.17222 5.45159C3.73753 6.71497 4.99716 7.53125 6.38119 7.53125H6.71574L1.89422 14.3491C1.1791 15.3603 0.769878 16.5312 0.710722 17.735C0.655175 18.8653 0.905066 20.0023 1.43339 21.0229C1.96168 22.0435 2.74561 22.904 3.70055 23.5113C4.7176 24.1581 5.90982 24.5 7.14839 24.5H21.8906V21.6875H23.2969V14.6562ZM21.8906 17.4688H15.328V16.0625H21.8906V17.4688ZM20.4844 14.6562H13.9217V13.25H20.4844V14.6562ZM6.62616 2.84061C8.352 2.78455 9.35508 2.57188 10.3293 2.36525C11.3067 2.15797 12.2366 1.96086 13.9128 1.91581C13.674 4.00517 12.4535 5.58603 11.9846 6.125H8.38219C7.98385 5.66731 7.04761 4.46403 6.62616 2.84061ZM7.14839 23.0938C5.23252 23.0938 3.56297 22.078 2.68228 20.3765C1.80155 18.675 1.93617 16.7253 3.04243 15.161L8.43807 7.53125H11.9289L14.9786 11.8438H12.5154V16.0625H13.9217V20.2812H12.5154V23.0938H7.14839ZM20.4844 23.0938H13.9217V21.6875H20.4844V23.0938ZM15.328 20.2812V18.875H21.8906V20.2812H15.328Z",
    fill: "#22283A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2010_5783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset);
export default __webpack_public_path__ + "static/media/asset.b30c2cb61fdfd221ba01c37b71674c72.svg";
export { ForwardRef as ReactComponent };